import { render } from "./Ecommerce.vue?vue&type=template&id=2c5fda79"
import script from "./Ecommerce.vue?vue&type=script&lang=js"
export * from "./Ecommerce.vue?vue&type=script&lang=js"

import "./Ecommerce.vue?vue&type=style&index=0&id=2c5fda79&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.8.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__